// extracted by mini-css-extract-plugin
export default {"box":"ShipmentDestination_box__48pqC","header":"ShipmentDestination_header__dcSq-","source":"ShipmentDestination_source__TzjQP"};